module.exports = __webpack_public_path__ + "static/media/must.c97065b5.jpg";